import React, { useEffect, useState } from 'react';
import { editarPdv, obterPdvPorId, atualizarModulosLicenca } from '../services/api';
import CadastroPdv from './CadastroPdv';
import CenteredAlert, { extrairMensagemErro } from './common/CenteredAlert';
import { useParams, useNavigate } from 'react-router-dom';

const EditarPdv = ({ token }) => {
  const [initialData, setInitialData] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await obterPdvPorId(id, token);
        setInitialData(response.data);
        setLoadError(null);
      } catch (error) {
        console.error('Erro ao carregar os dados do PDV:', error);
        setLoadError(extrairMensagemErro(error, 'Erro ao carregar os dados do PDV.'));
      }
    };
    fetchData();
  }, [id, token]);

  const handleEditSubmit = async (data, token, { itensModulos = [] } = {}) => {
    await editarPdv(id, data, token);
    if (itensModulos.length > 0) {
      await atualizarModulosLicenca('ZenPDV', Number(id), itensModulos, token);
    }
  };

  if (loadError) {
    return (
      <>
        <CenteredAlert
          show
          variant="error"
          message={loadError}
          onClose={() => navigate('/licenciamento/zenpdv')}
        />
        <div className="max-w-3xl mx-auto p-6 text-center text-gray-500">Carregando...</div>
      </>
    );
  }

  if (!initialData) {
    return <div className="max-w-3xl mx-auto p-6 text-center text-gray-500">Carregando...</div>;
  }

  return (
    <CadastroPdv
      token={token}
      initialData={initialData}
      onSubmit={handleEditSubmit}
      isEdit={true}
      licencaId={Number(id)}
      successMessage="PDV atualizado com sucesso!"
      onSaveSuccess={() => navigate('/licenciamento/zenpdv')}
    />
  );
};

export default EditarPdv;
